export default __webpack_public_path__ + "static/wellness-5b06c5b9a526d72841f74a12bd280dba.png";